export default __webpack_public_path__ + "static/media/nvidia-inception-program-badge-rgb-for-screen.2f33635d.svg";